import * as React from "react";

interface IndustryLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export const IndustryLayout: React.FC<IndustryLayoutProps> = ({ title, subtitle, children }) => {
  return (
    <div>
      <header className="bg-[hsl(var(--section-subtle))]">
        <div className="container mx-auto py-10 md:py-14">
          <h1 className="text-3xl md:text-4xl font-semibold">{title}</h1>
          {subtitle && <p className="mt-3 text-muted-foreground max-w-2xl">{subtitle}</p>}
        </div>
      </header>
      <main className="container mx-auto py-10">
        {children}
      </main>
    </div>
  );
};
